import { pipelineId, integrationId, pipelineIntegrationId } from '../fixture-ids';

export const pipelineIntegrationLegacyAlternates = {
  // The join row's own id identifies a row nobody can navigate to, so the row is diffed but
  // cannot say WHICH integration changed; `unattributed` on the alias says so. The name key is how
  // these rows, which carry no pipelineId, reach their pipeline's history. Without it they matched
  // only through another entry's pipelineName term. It leaves current rows attributed, because
  // they carry pipelineId.
  PIPELINE_INTEGRATION_UPDATED: {
    idKeys: [{ key: 'pipelineIntegrationId', entity: 'pipelineIntegration', unattributed: true }],
    parentNameKeys: [{ key: 'pipelineName', entity: 'pipeline' }],
  },
};

export const pipelineIntegrationLegacyFixtures = {
  INTEGRATION_ADDED_TO_PIPELINE: {
    action: 'INTEGRATION_ADDED_TO_PIPELINE',
    debugData: { pipelineId, pipelineName: 'Web Analytics', integrationId, integrationName: 'Google Analytics 4' },
  },
  // Legacy carries an extra own `id` the current trigger never emits. The entry's compositeIdKeys
  // tuple is present too, so no idKeys alias is declared for it -- it renders as an ordinary
  // field, not as identity.
  INTEGRATION_REMOVED_FROM_PIPELINE: {
    action: 'INTEGRATION_REMOVED_FROM_PIPELINE',
    debugData: {
      id: pipelineIntegrationId,
      pipelineId,
      pipelineName: 'Web Analytics',
      integrationId,
      integrationName: 'Google Analytics 4',
    },
  },
  PIPELINE_INTEGRATION_UPDATED: {
    action: 'PIPELINE_INTEGRATION_UPDATED',
    debugData: { pipelineIntegrationId, pipelineName: 'Web Analytics', integrationName: 'Google Analytics 4' },
  },
};
